<template>
  <div class="card-component">
    <p class="card-caption-title">対応内容一覧</p>
    <div v-if="callHistoryDataList.length > 0">
      <table>
        <tr v-for="(history, index) in callHistoryDataList" :key="index">
          <td>
            <a
              v-if="history.callId != parentCallId"
              @click="goToAnotherCallDetail(history.callId)"
              class="underline"
              >{{ history.callId }}</a
            >
            <p v-else>{{ history.callId }}</p>
          </td>
          <td>
            <router-link
              v-if="history.escalationId"
              :to="{ name: 'EscalationDetail', params: { escalationId: history.escalationId } }"
              class="underline"
            >エスカレ有</router-link
            >
            <p v-else>エスカレ無</p>
          </td>
          <td>{{ formatDatetime(history.callImplementationDate, history.callStartTime) }}</td>
          <td>{{ history.callType }}</td>
          <td>
            <p class="hearing-content">
              <span v-if="history.hearing4">{{ history.hearing4 }}</span>
              <span v-else-if="history.hearing3">{{ history.hearing3 }}</span>
              <span v-else-if="history.hearing2">{{ history.hearing2 }}</span>
              <span v-else-if="history.hearing1">{{ history.hearing1 }}</span>
            </p>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <p>対応内容はありません</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parentCallId: {
      type: String,
      default: ""
    },
    callHistoryDataList: {
      type: Array,
      default() {
        return [];
      },
    },
    searchConditions: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  methods: {
    formatDatetime(date, time) {
      let replacedDate = date.replace(/-/g, "/");
      let splittedTime = time.split(":");
      return `${replacedDate} ${splittedTime[0]}:${splittedTime[1]}`;
    },
    goToAnotherCallDetail(callId) {
      this.$emit("anotherCallDetail", callId);
    }
  }
};
</script>

<style scoped>
.card-component {
  padding: 10px;
  margin-top: 0.5em;
  border: 1px solid;
  border-radius: 5px;
}
.subtitle {
  margin: 0.5em 0 1em 0;
}
.card-caption-title {
  font-size: 18px;
  margin-bottom: 0.5em;
}
table tr {
  border-top: 1px solid;
}
table tr th {
  width: 35%;
  font-size: 15px;
  padding: 0.2em 0;
  vertical-align: top;
}
table tr td {
  font-size: 15px;
  padding: 0.5em 0.2em;
  width: 13%;
}
table tr td:last-child {
  font-size: 15px;
  padding: 0.5em 0.2em;
  width: 40%;
}
table tr td > * {
  width: 100%;
}
.underline {
  text-decoration: underline;
}
.hearing-content {
  word-break: break-all;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/call/components/CallHistoryDetailCard.vue